import React, { useState, useEffect } from "react";
import FloatingSidebarTwo from "modules/Common/Components/FloatingSidebarTwo";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";
import { ASSET_LIST, CAMPAIGNS_LIST, GET_CAMPAIGNS_NAMES_ONLY } from "constants/types";
import CampaignAsider from "./CampaignAsider";
import { createNewCampaignSerialize, resetAllData } from "modules/Campaigns/utils";
import { closeDetailProfile, closeOverlay, dynamicBody, openOverlay } from "modules/GlobalActions";
import { useSelector } from "react-redux";
import { RootState } from "store";
import {
  clearPeopleSearch,
  dynamicAudienceSearch,
  getRecommendedLists,
  getRecommendedPeople,
  resetSelectAllRecommendedContactsAction,
  searchLists,
  searchPeople,
  setDynamicKeywordsAction,
  testCampaignKeywords,
} from "../actions";
import { getContactDashboard, getContactSubscriptions } from "modules/Campaigns/Audience/actions";
import { createCampaign } from "modules/Campaigns/Emails/actions";

interface ICreateCampaign {
  similarContactNames?: string[];
  similarContactIds?: any[];
  keywords?: string[];
  createCampaignSiderId?: string;
  disabled?: boolean;
  hideDynamic?: boolean;
  contactSidebarId?: string;
  inDetailProfile?: boolean;
  inCreateCampaign?: boolean;
}

const CreateCampaign: React.FC<ICreateCampaign> = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [showCreateCampaignAsider, setShowCreateCampaignAsider] = useState(false);
  const [showAudienceAsider, setShowAudienceAsider] = useState(false);
  const [isTextAsider, setIsTextAsider] = useState(true);
  const [toggleCampaignSaveDisable, setToggleCampaignSaveDisable] = useState("disabled");
  const [campaignName, setCampaignName] = useState("");
  const [campaignKeywords, setCampaignKeywords] = useState(props?.keywords ? props?.keywords : Array<string>());
  const recommendedPeopleLength = useSelector((state: RootState) => state.recommendedPeople.data.length);
  const recommendedPeopleSearchTerm = useSelector((state: RootState) => state.recommendedPeople.searchTerm);
  const recommendedListLength = useSelector((state: RootState) => state.recommendedLists.data.length);
  const isOverlay = useSelector((state: RootState) => state.uiReducer.overlay);
  const showDetailProfile = useSelector((state: RootState) => state.audience.showDetailProfile);
  const advancedSearchCheck: boolean = useSelector((state: RootState) => state.uiReducer.advancedSearchCheck);
  const sourcedContent = useSelector((state: RootState) => state.searchArticles.sourcedContent);
  const excludedContent = useSelector((state: RootState) => state.searchArticles.excludedContent);
  const excludedKeywords = useSelector((state: RootState) => state.searchArticles.excludedKeywords);
  const includedKeywords = useSelector((state: RootState) => state.searchArticles.includedKeywords);

  const isSelectAllRecommendedLists = useSelector((state: RootState) => state.selectedRecommendedList.isSelectAllRecommendedLists);
  const recommendedSelectedListsIds = useSelector((state: RootState) => state.selectedRecommendedList.selectedListsIds);
  const recommendedSelectedLists = useSelector((state: RootState) => state.selectedRecommendedList.selectedLists);

  const selectedRecommendedContactsIds = useSelector((state: RootState) => state.recommendedPeople.selectedRecommendedContactsIds);
  const selectedRecommendedContacts = useSelector((state: RootState) => state.recommendedPeople.selectedRecommendedContacts);
  const isSelectAllRecommendedContacts = useSelector((state: RootState) => state.recommendedPeople.isSelectAllRecommendedContacts);

  const selectAllRecommendedContacts = useSelector((state: RootState) => state.selectedRecommendedContacts.selectAllRecommendedContacts);
  const unSelectAllRecommendedContacts = useSelector((state: RootState) => state.selectedRecommendedContacts.unSelectAllRecommendedContacts);

  const selectAllRecommendedSearchContacts = useSelector((state: RootState) => state.selectedRecommendedContacts.selectAllRecommendedSearchContacts);
  const unSelectAllRecommendedSearchContacts = useSelector((state: RootState) => state.selectedRecommendedContacts.unSelectAllRecommendedSearchContacts);

  const selectAllRecommendedDynamicContacts = useSelector((state: RootState) => state.selectedRecommendedContacts.selectAllRecommendedDynamicContacts);
  const unSelectAllRecommendedDynamicContacts = useSelector((state: RootState) => state.selectedRecommendedContacts.unSelectAllRecommendedDynamicContacts);
  const dynamicAudienceKeywords = useSelector((state: RootState) => state.recommendedPeople.dynamicAudienceKeywords);

  const selectedContactsReducer = useSelector((state: RootState) => state.selectedRecommendedContacts.selectedContacts);

  useEffect(() => {
    setCampaignKeywords(props?.keywords ? props?.keywords : Array<string>());
    if (props?.keywords) {
      setDynamicKeywordsAction(props?.keywords);
    }

  }, [props.keywords]);

  useEffect(() => {
    if (campaignKeywords?.length !== dynamicAudienceKeywords?.length) {
      setDynamicKeywordsAction(campaignKeywords);
    }
    return () => {

    };
  }, [campaignKeywords]);


  const [selectedContactIds, setSelectedContactIds] = useState(
    props?.similarContactIds ? props?.similarContactIds : Array<number>()
  );

  const [selectedContactNames, setSelectedContactNames] = useState(
    props?.similarContactNames ? props?.similarContactNames : Array<string>()
  );

  const [selectedListIds, setSelectedListIds] = useState(Array<number>());
  const [selectedListNames, setSelectedListNames] = useState(Array<string>());


  function handleOnRemoveCampaignKeyword(searchTermId: string, isExtended: boolean) {
    const updatedCampaignKeywords = [...campaignKeywords];
    const index = updatedCampaignKeywords.indexOf(searchTermId);
    if (index >= 0) {
      updatedCampaignKeywords.splice(index, 1);
      setCampaignKeywords(updatedCampaignKeywords);
    }
    if (recommendedPeopleSearchTerm !== "" && updatedCampaignKeywords.length === 0) {
      searchPeople(0, 50, recommendedPeopleSearchTerm, false);
    } else if (recommendedPeopleSearchTerm === "" && updatedCampaignKeywords.length === 0) {
      dynamicAudienceSearch(0, 50, "", updatedCampaignKeywords.toString(), false);
    } else if (recommendedPeopleSearchTerm !== "" && updatedCampaignKeywords.length > 0) {
      dynamicAudienceSearch(0, 50, recommendedPeopleSearchTerm, updatedCampaignKeywords.toString());
    }
    // searchPeople(0, 50, updatedCampaignKeywords.toString(), updatedCampaignKeywords.length > 0);
    // dynamicAudienceSearch(0, 50, "", updatedCampaignKeywords.toString());
    searchLists(updatedCampaignKeywords.toString(), true);
    setDynamicKeywordsAction(updatedCampaignKeywords);
  }



  useEffect(() => {
    if (selectAllRecommendedContacts || selectAllRecommendedSearchContacts
      || selectAllRecommendedDynamicContacts || selectedContactsReducer.length !== selectedContactIds.length) {
      // console.log("select all recommended: ", selectedContactsReducer)
      let selectedContactIdsNew = selectedContactsReducer.map((contact: any) => contact.id);
      let selectedContactNamesNew = selectedContactsReducer.map((contact: any) => contact?.name?.trim() === "" ? contact?.email : contact?.name?.trim());
      // let selectedContactNamesRecommended = selectedRecommendedContacts.map((contact: any) => contact?.name?.trim() === "" ? contact?.email : contact?.name?.trim());
      // let selectedContactNamesNew = [...new Set([...selectedContactNamesRecommended, ...selectedContactNames])];
      setSelectedContactIds(selectedContactIdsNew);
      setSelectedContactNames(selectedContactNamesNew);
    }
    // else if (unSelectAllRecommendedContacts) {
    //   console.log("unselect all recommended");
    //   let selectedContactIdsNew = selectedContactsReducer.map((contact: any) => contact.id);
    //   let selectedContactNamesNew = selectedContactsReducer.map((contact: any) => contact?.name?.trim() === "" ? contact?.email : contact?.name?.trim());

    //   setSelectedContactIds([...selectedContactIdsNew]);
    //   setSelectedContactNames([...selectedContactNamesNew]);
    // } else {
    //   console.log("no recommended")
    // }
  }, [selectAllRecommendedContacts, selectAllRecommendedSearchContacts, selectAllRecommendedDynamicContacts, selectedContactsReducer])


  useEffect(() => {
    props?.similarContactIds && setSelectedContactIds(props?.similarContactIds);
    props?.similarContactNames && setSelectedContactNames(props?.similarContactNames);
  }, [props.similarContactIds, props.similarContactNames]);


  useEffect(() => {
    if (isSelectAllRecommendedLists) {
      let selectedListIdsNew = [...new Set([...recommendedSelectedListsIds, ...selectedListIds])];
      let selectedListNamesRecommended = recommendedSelectedLists.map((list: any) => list.name?.trim());
      let selectedListNamesNew = [...new Set([...selectedListNamesRecommended, ...selectedListNames])];
      setSelectedListIds(selectedListIdsNew);
      setSelectedListNames(selectedListNamesNew);
    } else {
      setSelectedListIds([]);
      setSelectedListNames([]);
    }

  }, [isSelectAllRecommendedLists])

  // useEffect(() => {
  //   if (isSelectAllRecommendedContacts) {
  //     let selectedContactIdsNew = [...new Set([...selectedRecommendedContactsIds, ...selectedContactIds])];
  //     let selectedContactNamesRecommended = selectedRecommendedContacts.map((contact: any) => contact?.name?.trim() === "" ? contact?.email : contact?.name?.trim());
  //     let selectedContactNamesNew = [...new Set([...selectedContactNamesRecommended, ...selectedContactNames])];
  //     setSelectedContactIds(selectedContactIdsNew);
  //     setSelectedContactNames(selectedContactNamesNew);
  //   }
  // }, [isSelectAllRecommendedContacts]);



  function handleOnClickTestKeywords() {
    setIsTextAsider(true);
    setShowAudienceAsider(true);
    if (campaignKeywords.length > 0) testCampaignKeywords(campaignKeywords);
  }

  function handleOnClickBrowsePeople() {
    if (recommendedPeopleLength === 0 && campaignKeywords.length === 0) {
      getRecommendedPeople(0, 50);
    } else {
      if (recommendedPeopleSearchTerm !== "" && campaignKeywords.length === 0) {
        searchPeople(0, 50, recommendedPeopleSearchTerm, false);
      } else if (recommendedPeopleSearchTerm === "" && campaignKeywords.length === 0) {
        dynamicAudienceSearch(0, 50, "", campaignKeywords.toString(), false);
      } else if (recommendedPeopleSearchTerm !== "" && campaignKeywords.length > 0) {
        dynamicAudienceSearch(0, 50, recommendedPeopleSearchTerm, campaignKeywords.toString());
      }
      // searchPeople(0, 50, campaignKeywords.toString(), true);
      // dynamicAudienceSearch(0, 50, "", campaignKeywords.toString());
    }
    if (recommendedListLength === 0 && campaignKeywords.length === 0) {
      getRecommendedLists();
    } else {
      searchLists(campaignKeywords.toString(), true);
      // dynamicAudienceSearch(0, 50, "", campaignKeywords.toString());
    }
    setIsTextAsider(false);
    setShowAudienceAsider(true);
  }

  function handleAddPeople(id: number, name: string, audience_type: string, email?: string) {
    if (audience_type === "contact") {
      if (name === "" && email !== undefined) {
        name = email;
      }
      if (selectedContactIds.indexOf(id) < 0) {
        setSelectedContactIds([...selectedContactIds, id]);
        setSelectedContactNames([...selectedContactNames, name]);
      } else {
        handleRemovePeople(id, name, audience_type);
      }
    } else if (audience_type === "list") {
      if (selectedListIds.indexOf(id) < 0) {
        setSelectedListIds([...selectedListIds, id]);
        setSelectedListNames([...selectedListNames, name]);
      } else {
        handleRemovePeople(id, name, audience_type);
      }
    }
  }

  function handleRemovePeople(id: number, name: string, audience_type: string) {
    if (audience_type === "contact") {
      const updatedContactIds = [...selectedContactIds];
      const updatedContactNames = [...selectedContactNames];
      let index = updatedContactIds.indexOf(id);
      if (index >= 0) {
        updatedContactIds.splice(index, 1);
        updatedContactNames.splice(index, 1);
        setSelectedContactIds(updatedContactIds);
        setSelectedContactNames(updatedContactNames);
      }
    } else if (audience_type === "list") {
      const updatedListIds = [...selectedListIds];
      const updatedListNames = [...selectedListNames];
      let index = updatedListIds.indexOf(id);
      if (index >= 0) {
        updatedListIds.splice(index, 1);
        updatedListNames.splice(index, 1);
        setSelectedListIds(updatedListIds);
        setSelectedListNames(updatedListNames);
      }
    }
  }

  function onClickAudienceDone() {
    setShowAudienceAsider(false);
  }

  function handleCreateNewCampaign() {
    setToggleCampaignSaveDisable("disabled");
    createCampaign(
      campaignName.trim(),
      campaignKeywords,
      selectedContactIds,
      selectedListIds,
      advancedSearchCheck,
      sourcedContent,
      excludedContent,
      excludedKeywords,
      includedKeywords
    )
      .then((res: any) => {
        if (res.data.success === true) {
          dispatch({
            type: ASSET_LIST.SET_CAMPAIGN_DETAILS,
            campaign_name: campaignName,
            campaign_keywords: campaignKeywords,
          });
          // // dispatch new campaign to asset asider campaign names list
          dispatch({
            type: GET_CAMPAIGNS_NAMES_ONLY.SUCCESS,
            payload: [{ campaign_id: res.data.campaign_id, name: campaignName }],
            newlyAdded: true,
          });
          const serializedCampaign = createNewCampaignSerialize(res.data);
          dispatch({
            type: CAMPAIGNS_LIST.ADD_NEW,
            payload: serializedCampaign,
            similarContactsCount: selectedContactIds.length,
          });
          resetAllData();
          resetSelectAllRecommendedContactsAction();
          clearPeopleSearch(); // reset search field when closing the asider

          if (history.location.pathname !== "/content/search") {
            closeDetailProfile();
            history.push("/campaigns/content/source?campaign_id=" + res.data.campaign_id);
          }

          if (
            history.location.pathname.startsWith("/audiences/people") ||
            history.location.pathname.startsWith("/audiences/lists")
          ) {
            setShowCreateCampaignAsider(false);
            props?.contactSidebarId && getContactDashboard(props?.contactSidebarId);
            props?.contactSidebarId && getContactSubscriptions(props?.contactSidebarId);
          }
          if (history.location.pathname === "/content/search") {
            setShowCreateCampaignAsider(false);
            history.push("/campaigns/content/source?campaign_id=" + res.data.campaign_id);
          }
        } else {
          console.log(res);
          setToggleCampaignSaveDisable("");
        }
      })
      .catch((err: any) => {
        console.log(err);
        setToggleCampaignSaveDisable("");
      });
  }

  useEffect(() => {
    if (showCreateCampaignAsider === false) handleCancelCreateCampaign();
  }, [showCreateCampaignAsider]);

  function handleCancelCreateCampaign() {
    //* empty out the state when user clicks on the cancel form button
    setCampaignName("");
    setCampaignKeywords(Array<string>());
    setDynamicKeywordsAction([]);
    resetSelectAllRecommendedContactsAction();
    clearPeopleSearch(); // reset search field when closing the asider

    if (props.inDetailProfile) {
      props?.similarContactIds && setSelectedContactIds(props?.similarContactIds);
      props?.similarContactNames && setSelectedContactNames(props?.similarContactNames);
    } else {
      setSelectedContactIds(Array<number>());
      setSelectedContactNames(Array<string>());
    }
    setSelectedListIds(Array<number>());
    setSelectedListNames(Array<string>());
    setShowAudienceAsider(false);

    //* Toggle the show aside and the black overlay
    // setShowCreateCampaignAsider(false);
    !props.inDetailProfile && closeOverlay();
  }

  // if (showCreateCampaignAsider) {
  //   openOverlay();
  // }

  const newCloseMethod = () => {
    setShowCreateCampaignAsider(false);
    !props.inDetailProfile && closeOverlay();
  };

  useEffect(() => {
    // openOverlay();
    if (showDetailProfile) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "auto";

    return () => {
      document.body.style.overflow = "auto";
      setShowCreateCampaignAsider(false);
    };
  }, [showDetailProfile]);

  useEffect(() => {
    if (showCreateCampaignAsider && !isOverlay) {
      setShowCreateCampaignAsider(false);
    }
  }, [isOverlay]);

  return (
    <>
      <div
        onClick={() => {
          if (!props.disabled) {
            if (!props?.hideDynamic) dynamicBody();
            openOverlay();
            setShowCreateCampaignAsider(true);
          }
        }}
      >
        {props.children}
      </div>

      <FloatingSidebarTwo
        inCreateCampaign={props.inCreateCampaign}
        isToggle={showCreateCampaignAsider && isOverlay}
        className="campaign-asider"
        isText={isTextAsider}
        keywordAsider={true}
        isToggleAsider={showAudienceAsider}
        campaignKeywords={campaignKeywords}
        setCampaignKeywords={setCampaignKeywords}
        handleAddPeople={handleAddPeople}
        onClickAudienceDone={onClickAudienceDone}
        selectedContactIds={selectedContactIds}
        selectedListIds={selectedListIds}
        rightSidebarId={props.createCampaignSiderId}
      >
        <CampaignAsider
          inDetailProfile={props.inDetailProfile}
          aToggle={true}
          onCancel={newCloseMethod}
          showAudienceAsider={showAudienceAsider} // for checking when audience sider gets
          campaignKeywords={campaignKeywords}
          setCampaignKeywords={setCampaignKeywords}
          handleOnRemoveCampaignKeyword={handleOnRemoveCampaignKeyword}
          handleAddPeople={handleAddPeople}
          campaignName={campaignName}
          setCampaignName={setCampaignName}
          selectedContactNames={selectedContactNames}
          selectedContactIds={selectedContactIds}
          selectedListIds={selectedListIds}
          selectedListNames={selectedListNames}
          handleOnClickTestKeywords={handleOnClickTestKeywords}
          handleOnClickBrowsePeople={handleOnClickBrowsePeople}
          handleCreateNewCampaign={handleCreateNewCampaign}
          toggleCampaignSaveDisable={toggleCampaignSaveDisable}
          setToggleCampaignSaveDisable={setToggleCampaignSaveDisable}
        />
      </FloatingSidebarTwo>
      {/* {showCreateCampaignAsider ? <CreateCampaignSteps hideSteps={showAudienceAsider} /> : null} */}
    </>
  );
};

export default CreateCampaign;
